import React from "react"

import { Helmet } from "react-helmet"
import { useLocation } from "@gatsbyjs/reach-router"

import {
  PodZalogDefault,
  Nedvizhimosti,
  DefaultCredit,
  Exceptions,
  RefinansirovanieKredita,
  Auto,
  PodZalogPensioneram,
  Zaim,
  MsbLizing,
} from "./Schema"

const htmlAttributes = {
  lang: "ru",
}
const defTitle = "Взять кредит онлайн - заявка на кредит наличными - Совкомбанк"
const defDescription =
  "Заполните онлайн заявку на кредит наличными – это займет всего несколько минут. Получите одобрение и заберите деньги в офисе Банка или доставкой курьером!"
const author = "@sovcombank"

const exceptionsUrl = [
  "100000-na-kartu",
  "bez-kreditnoj-istorii",
  "bystryj-kredit-nalichnymi",
  "kalkulyator-dosrochnogo-pogasheniya-kredita",
  "30000-rublej",
  "40000-rublej",
]

export type SEOProps = {
  title?: string
  description?: string
  titleH1?: string
  shortTitle?: string
  FAQ?: JSX.Element[][]
  url?: string
}

export function SEO({
  title = defTitle,
  description = defDescription,
  titleH1,
  shortTitle,
  FAQ,
  url,
}: SEOProps) {
  const { pathname }: Location = useLocation()

  const meta = [
    { property: "og:title", content: title },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { name: "twitter:creator", content: author },
    { name: "twitter:title", content: title },
    { name: "description", content: description },
    { property: "og:description", content: description },
    { name: "twitter:description", content: description },
    // отключает автоматическое определение текста как номер телефона в Safari
    { name: "format-detection", content: "telephone=no" },
  ]

  // свойства объекта местами не менять, может сбиться микроразметка на других страницах
  const pathToComponent = {
    "refinansirovanie-kredita": RefinansirovanieKredita,
    zajm: Zaim,
    "pod-zalog/auto": Auto,
    "pod-zalog/pensioneram": PodZalogPensioneram,
    "pod-zalog/nedvizhimosti": Nedvizhimosti,
    "pod-zalog/": PodZalogDefault,
    "msb/lizing": MsbLizing,
  }

  const renderComponent = () => {
    // Проверка на наличие пути в exceptionsUrl
    if (exceptionsUrl.some((exception) => pathname?.includes(exception))) {
      return (
        <Exceptions url={url} description={description} titleH1={titleH1} />
      )
    }

    const path = Object.keys(pathToComponent).find((key) =>
      pathname?.includes(key)
    )

    if (path) {
      const Component = pathToComponent[path as keyof typeof pathToComponent]

      return (
        <Component
          url={url}
          shortTitle={shortTitle}
          description={description}
          titleH1={titleH1}
          FaqItem={FAQ}
        />
      )
    }

    return (
      <DefaultCredit url={url} description={description} titleH1={titleH1} />
    )
  }

  return (
    <>
      <Helmet htmlAttributes={htmlAttributes} title={title} meta={meta} />
      {process.env.GATSBY_PATH_PREFIX?.includes("apply/credit") &&
        renderComponent()}
    </>
  )
}
